import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';

export const copyText = async (text: string) => {
  try {
    await navigator.clipboard.writeText(text);
    alert('링크가 복사되었습니다.');
  } catch (err) {
    alert('복사를 실패했습니다.');
  }
};

export const shareKakao = (currentUrl, name) => {
  const { Kakao } = window;
  Kakao.Share.sendScrap({
    requestUrl: currentUrl,
    templateId: 83227,
    templateArgs: { url: currentUrl, name: name },
  });
};

export const shareFacebook = (currentUrl) => {
  window.open(`http://www.facebook.com/sharer.php?u=${currentUrl}`);
};

export const shareTwitter = (currentUrl) => {
  window.open(`https://twitter.com/intent/tweet?url=${currentUrl}`);
};

export const divToPdf = (div, round) => {
  html2canvas(div, {
    scale: 2,
  }).then((canvas) => {
    const imgData = canvas.toDataURL('image/jpeg');
    const pdf = new jsPDF('l', 'mm', 'a4');
    let pageWidth = pdf.internal.pageSize.getWidth();
    let pageHeight = pdf.internal.pageSize.getHeight();
    const imageWidth = 1756;
    const imageHeight = 1237;
    const ratio =
      imageWidth / imageHeight >= pageWidth / pageHeight
        ? pageWidth / imageWidth
        : pageHeight / imageHeight;
    pdf.addImage(
      imgData,
      'JPEG',
      0,
      0,
      imageWidth * ratio,
      imageHeight * ratio,
    );
    pdf.save(`항해99 ${round} 수료증.pdf`);
  });
};

export const animateValue = (obj, start, end, duration) => {
  let startTimestamp = null;
  const step = (timestamp) => {
    if (!startTimestamp) {
      startTimestamp = timestamp;
    }
    const progress = Math.min((timestamp - startTimestamp) / duration, 1);
    obj.innerHTML = Math.floor(progress * (end - start) + start);
    if (progress < 1) {
      window.requestAnimationFrame(step);
    }
  };
  window.requestAnimationFrame(step);
};
